import {
  Component, OnInit, ViewChild, ElementRef, Output, EventEmitter,
  Renderer2, AfterContentInit, OnDestroy, ViewEncapsulation, DoCheck
} from '@angular/core';
import _ from 'lodash';

import jsonData from './data.json';
import { style } from '@angular/animations';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';

declare const d3: any;

@Component({
  selector: 'app-nlp-buisness-view-new',
  templateUrl: './nlp-buisness-view-new.component.html',
  styleUrls: ['./nlp-buisness-view-new.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NlpBuisnessViewNewComponent implements OnInit, DoCheck, AfterContentInit, OnDestroy {

  @ViewChild('container') container: ElementRef;
  @ViewChild('content') content: ElementRef;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onVisibleSectionChange = new EventEmitter<any>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onLoad = new EventEmitter<any>();

  private sectionDimention: any;
  private problemSection = null;
  private dataSection = null;
  private solutionSection = null;
  private outcomesSection = null;
  private unsubscribeResize = null;
  private unsubscribeAnimationFrame = null;
  private unsubscribeTypingAnimation = null;
  private solutionContainer = { ele: null, scrollHeight: 0, top: 0 };
  private colors = ['#C94C64', '#4367B2', '#1DA1F2', '#C565C9', '#50D19A', '#C9B14C'];
  private _lastHeight: number ;


  data_problem_circle_wall = [65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65, 65];
  structureData = [];
  constructor(private renderer: Renderer2, private _gaService: GoogleAnalyticsService) { }

  ngDoCheck(): void {
    const scrollWindowHeight = document.getElementById('scroll-container').offsetHeight;
    if (this._lastHeight !== scrollWindowHeight) {
      this._lastHeight = scrollWindowHeight;
      this.calculateScaleAndDomain();
    }
  }

  ngAfterContentInit(): void {
    document.getElementById('bubble-wrap-show').className += ' show';
    this.calculateScaleAndDomain();
    this.unsubscribeResize = this.renderer.listen(window, 'resize', _.debounce(() => {
      this.problemSection.resize();
      this.dataSection.resize();
      this.solutionSection.resize();
      this.outcomesSection.resize();
      this.calculateScaleAndDomain();
    }, 700));
  }

  private calulateHeightAndTop(obj, main) {
    obj.top = obj.ele.offsetTop - main.top;
    obj.scrollHeight = obj.ele.offsetHeight - main.height;
  }
  private calculateScaleAndDomain() {
    const main = d3.select('#scroll-container').node(0).getBoundingClientRect();

    this.solutionContainer.ele = d3.select('#solution').node(0);
    this.solutionContainer.ele.style.height = (main.height * 4 + 'px');
    // d3.select('#solution-txt-one').style('top', `${main.height}px`);
    // d3.select('#solution-txt-two').style('top', `${main.height * 2}px`);
    // d3.select('#solution-txt-three').style('top', `${main.height * 3}px`);
    this.calulateHeightAndTop(this.solutionContainer, main);

    const problem = d3.select('#problem').node(0).getBoundingClientRect();
    const data = d3.select('#data').node(0).getBoundingClientRect();
    const solution = d3.select('#solution').node(0).getBoundingClientRect();
    const outcomes = d3.select('#outcomes').node(0).getBoundingClientRect();
    const halfViewPort = main.height / 2;
    const size: any = {};
    size.problem = {
      top: 0,
      bottom: problem.height,
      scrollStart: 0,
      scrollLeave: problem.height - main.height,
      scrollEnd: problem.height
    };
    size.data = {
      top: size.problem.bottom + 1,
      bottom: size.problem.bottom + data.height,
      scrollStart: size.problem.bottom + 1,
      scrollLeave: (size.problem.bottom + data.height - main.height),
      scrollEnd: (size.problem.bottom + data.height)
    };
    size.solution = {
      top: size.data.bottom + 1,
      bottom: size.data.bottom + solution.height,
      scrollStart: size.data.bottom + 1,
      scrollLeave: (size.data.bottom + solution.height - main.height),
      scrollEnd: (size.data.bottom + solution.height)
    };
    size.outcomes = {
      top: size.solution.bottom + 1,
      bottom: size.solution.bottom + outcomes.height,
      scrollStart: size.solution.bottom + 1,
      scrollLeave: (size.solution.bottom + outcomes.height - main.height),
      scrollEnd: (size.solution.bottom + outcomes.height - main.height)
    };
    this.sectionDimention = size;
    this.problemSection.setScaleDomain(size.problem.scrollStart, size.problem.scrollLeave, size.problem.scrollEnd);
    this.dataSection.setScaleDomain(size.problem.scrollLeave, size.data.scrollLeave, size.data.scrollEnd, halfViewPort);
    this.solutionSection.setScaleDomain((size.data.scrollLeave + halfViewPort), size.solution.scrollLeave, size.solution.scrollEnd, halfViewPort);
    this.outcomesSection.setScaleDomain((size.solution.scrollLeave + main.height / 4), size.outcomes.scrollLeave, size.outcomes.scrollEnd);
  }
  ngOnInit() {
    this.onLoad.emit({
      sections: [
        {
          'name': 'Problem'
        },
        {
          'name': 'Insights'
        },
        {
          'name': 'Solution'
        },
        {
          'name': 'Outcomes'
        }
      ]
    });
    this.renderStory();
  }

  private renderStory() {
    let _scrollTop = 0;
    let _newScrollTop = 0;
    const that = this;
    d3.select('#scroll-container').on('scroll.scroller', function () {
      _newScrollTop = d3.select(this).node(0).scrollTop;
      // console.log(_newScrollTop);
      if (_newScrollTop >= that.solutionContainer.top
        && _newScrollTop < (that.solutionContainer.top + that.solutionContainer.scrollHeight)) {
        // console.log('sticky Class', _newScrollTop);
        that.renderer.addClass(that.solutionContainer.ele, 'stick');
      } else {
        that.renderer.removeClass(that.solutionContainer.ele, 'stick');
      }
    });
    this.problemSection = this.initProblemSection('problem');
    this.dataSection = this.initDataSection('data');
    this.solutionSection = this.initSolutionSection('solution-svg-container');
    this.outcomesSection = this.initOutcomesSection('outcomes-svg-container');

    /**
    * Render function
    * This function is recurcive function and called to show animation on every scroll change.
    */
    const render = () => {
      if (_scrollTop !== _newScrollTop) {
        _scrollTop = _newScrollTop;

        if (this.sectionDimention.problem.scrollStart <= _scrollTop
          && _scrollTop < this.sectionDimention.problem.scrollEnd + 100) {
          this.problemSection.startAnimation(_scrollTop);
        }
        if ((this.sectionDimention.problem.scrollLeave) < _scrollTop
          && _scrollTop < (this.sectionDimention.data.scrollEnd + 100)) {
          this.dataSection.startAnimation(_scrollTop);
        }
        if ((this.sectionDimention.data.scrollLeave) < _scrollTop
          && _scrollTop <= (this.sectionDimention.solution.scrollEnd + 100)) {
          this.solutionSection.startAnimation(_scrollTop);
        }
        if ((this.sectionDimention.solution.scrollLeave) < _scrollTop) {
          this.outcomesSection.startAnimation(_scrollTop);
        }
      }
      window.cancelAnimationFrame(this.unsubscribeAnimationFrame);
      this.unsubscribeAnimationFrame = window.requestAnimationFrame(render);
    };
    this.unsubscribeAnimationFrame = window.requestAnimationFrame(render);
  }


  private drawSymbolWall(rowCount, symbolPerRow, xAxis, svg) {
    const arc = d3.svg.symbol().type('square').size(36);
    const symbolData = [];
    const ids = _.shuffle(d3.range(symbolPerRow * rowCount));
    d3.range(rowCount).forEach((v, ind) => {
      d3.range(symbolPerRow).forEach((d, i) => {
        function color() {
          if (symbolPerRow === 50) {
            const t = getRandomIntInclusive(0, 10);
            if (t > 0) {
              return '#adacad';
            } else {
              return this.colors[getRandomIntInclusive(0, 5)];
            }
          } else if (ind >= 0 && ind <= 6) { return '#50d199'; } else if (ind >= 7 && ind <= 12) { return '#c8b14c'; } else if (ind >= 13 && ind <= 19) { return '#c565c9'; }

        }
        const randomVal = getRandomIntInclusive(0, 50);
        const size = 2.5;
        const finalY = 510;
        symbolData.push({
          x: (8 * i),
          y: (ind * 8),
          color: color(),
          id: 'data_symbol_wall_' + symbolPerRow + '_' + ids[((symbolPerRow * ind) + i)],
          opacity: 0,
          idCount: ids[(symbolPerRow * ind) + i],
          finalX: symbolPerRow === 17 ? getRandomIntInclusive(-345, 170) : getRandomIntInclusive(750, 1000),
          finalY: getRandomIntInclusive(494, 950),
          finalHideOn: finalY - (size * 10),
          ang: getRandomIntInclusive(0, 270),
          randomData: symbolPerRow === 17 ? (randomVal < 10 ? true : false) : (randomVal < 5 ? true : false),
          randomOpacity: getRandomArbitrary(0.2, 1),
          size// 2
        });
      });
    });
    const wallSymbol = svg.append('g')
      .attr('transform', 'translate(' + xAxis + ',' + 700 + ')')
      .selectAll('.wallSymbol')
      .data(symbolData)
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('stroke-width', 1)
      .each(function (d) {
        d3.select(this)
          .attr('d', arc)
          .attr('fill', d.color)
          .attr('stroke-width', 1)
          .attr('transform', 'translate(' + d.x + ',' + d.y + ')')
          .attr('class', 'wallSymbol')
          .attr('id', d.id)
          .style('opacity', d.opacity);
      });
    const textXaxis = symbolPerRow === 17 ? xAxis : (xAxis + 300);
    const wallText = svg.append('g')
      .append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': '100',
        'height': '20'
      })
      .html(symbolPerRow === 50 ? '<span style="color:#c94c63;font-weight:bold">VOLUME</span> OF DATA' : '<span style="color:#2931ff;font-weight:bold">QUALITY</span> OF DATA')
      .attr('transform', 'translate(' + textXaxis + ',' + 677 + ')');
    return {
      symbol: wallSymbol
    };
  }

  private responsivefy(svg, isHeightNotToUpdate = false) {
    const container = d3.select(svg.node().parentNode);
    const width = parseInt(svg.attr('width'), 10);
    const height = parseInt(svg.attr('height'), 10);
    const aspect = width / height;

    // get width of container and resize svg to fit it
    const resize = () => {
      const targetWidth = parseInt(container.style('width'), 10);
      svg.attr('width', targetWidth);
      let targetHeight = targetWidth / aspect;
      if (isHeightNotToUpdate) {
        // Set Container Height as is.
        targetHeight = container.node().getBoundingClientRect().height;
      }
      svg.attr('height', Math.round(targetHeight));
      return {
        widthAspect: targetWidth / width,
        heightAspect: targetHeight / height
      };
    };
    svg.attr('viewBox', '0 0 ' + width + ' ' + height)
      .attr('perserveAspectRatio', 'xMinYMid')
      .call(resize);

    return {
      resize,
      widthAspect: parseInt(svg.style('width'), 10) / width,
      heightAspect: parseInt(svg.style('height'), 10) / height
    };
  }

  private initProblemSection(containerId) {

    const container = d3.select('#' + containerId);
    const WIDTH = 1280 || container.node().clientWidth || container.node().offsetWidth;
    const HEIGHT_OFFSET = 1280 / 1280;
    const marginBottom = -20;
    const HEIGHT = WIDTH * HEIGHT_OFFSET;
    const svg = container.append('svg')
      .attr({
        width: WIDTH,
        height: HEIGHT
      });
    const { resize, heightAspect, widthAspect } = this.responsivefy(svg);

    const problemDataTypes = svg.append('g').attr({
      id: 'svg-problem-data-types',
      class: 'svg-problem-data-types',
      transform: 'translate(0, 800)'
    })
    .style('opacity', 0);

    const problemBannerGroup = svg.append('g')
      .attr({
        id: 'svg-problem-data',
        class: 'svg-problem-data'
      });
    problemBannerGroup.append('g')
      .append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': WIDTH,
        'height': HEIGHT
      })
      .html(`
      <div class="problem-banner">
      <h1>Unstructured Data</h1>
      <h3 class="mb-4">Around 90% of healthcare data is unstructured</h3>
      <div id ="bubble-wrap-show" class="bubble-wrap">
          <div class="ripple in">
              <div class="ripple-circles">
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
                <i></i>
              </div>
              <div class="bubble-arrow one"></div>
              <div class="bubble-arrow two"></div>
              <div class="bubble-arrow three"></div>
              <div class="bubble-arrow four"></div>
              <div class="bubble-arrow five"></div>
              <div class="bubble-arrow six"></div>
              <div class="bubble-arrow seven"></div>
          </div>
          <div class="intro one">6 months trastuzumab works as well as<br />
              12 months with less cardiac toxicity</div>
          <div class="intro two">You did a nice job today, the presentation<br />
              was high level yet balanced to larger groups</div>
          <div class="intro three">For treating PSA, dermatology clinicians are<br />
              interested in the newer MOA agents, such as IL-17</div>
          <div class="intro four">Hormone-sensitive prostate cancer as evident<br />
              by a testosterone level > 150 ng /dL at the time of<br />
              enrolment within 4 weeks prior to randomization</div>
          <div class="intro five">I typically treat a lot of metastatic Urothelial<br />
              Carcinoma patients with PD-L1 agents</div>
          <div class="intro six">I am calling to check if 50 ml this week is<br />
              fine as I am travelling over the weekend</div>
          <div class="intro seven">not working” Doctor: “I am going to add on<br />
              a oral medication in addition to Benlysta</div>
      </div>
  </div>`);

    const bgnodes = [];
    const mainNodes = jsonData.data_problem_raw;
    for (let i = 0; i < 12; i++) {
      for (let j = 0; j < 30; j++) {
        const d = {
          x: (j * getRandomIntInclusive(40, 45)),
          y: (i * getRandomIntInclusive(40, 45)) + 20,
          finalX: 640,
          finalY: 650,
          fx: getRandomIntInclusive(260, 1030),
          fyStart: 690,
          fy: getRandomIntInclusive(820, 900),
          ang: getRandomIntInclusive(-270, 270),
          size: (Math.random() * 4) + 1,
          id: `problem_square_${i}_${j}`,
          opacity: 0.09,
          finalOpacity: _.random(0.2, 1.0),
          color: this.colors[getRandomIntInclusive(0, this.colors.length - 1)]
        };
        bgnodes.push(d);
      }
    }
    const bgSquareNodes = problemBannerGroup.selectAll('.bgsquare')
      .data(bgnodes)
      .enter()
      .append('g')
      .each(function (d, i) {
        d3.select(this)
          .attr({
            'class': () => {
              let c = 'notToAnimate';
              if (getRandomIntInclusive(0, 4) === 0) {
                d.animate = true;
                c = 'toAnimate';
              }
              return `bgsquare ${c}`;
            },
            'id': d.id,
            'transform': `translate(${d.x}, ${d.y}) rotate(${d.ang}) scale(${d.size})`
          })
          .style({
            'opacity': d.opacity
          })
          .append('path')
          .attr({
            'd': () => d3.svg.symbol().type('square').size(36)(),
            'class': 'vibrate-animation'
          })
          .style({
            'fill': d.color
          });
      });
    const squareNodes = problemBannerGroup.selectAll('.square')
      .data(mainNodes)
      .enter()
      .append('g')
      .each(function (d, i) {
        d.finalX = 640; // 100 + (getRandomIntInclusive(0, 60) * 8);
        d.finalY = 650; // 700 + (getRandomIntInclusive(0, 18) * 8);
        d.scale = getRandomIntInclusive(5, 10);
        const size = 6;
        d3.select(this)
          .attr({
            'class': 'square toAnimate',
            'transform': `translate(${d.x}, ${d.y}) scale(${d.scale})`
          })
          .style('opacity', d.opacity)
          .append('g')
          .attr('class', 'vibrate-animation-slow');
        d3.select(this).select('g')
          .append('rect')
          .attr({
            height: size,
            width: size
          })
          .style({
            'opacity': 0.5,
            'fill': d.fill
          });
        d3.select(this).select('g')
          .append('image')
          .attr({
            'xlink:href': d.d,
            'width': size - 1,
            'height': size - 1,
            'transform': 'translate(.5, .5)'
          });
      });

    const dart = svg.append('g')
      .attr({
        id: 'problem-dart-circle',
        class: 'problem-dart-circle',
        'transform': `translate(0, 640)`
      }).append('g')
      .append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': WIDTH,
        'height': 556
      })
      .html(`
      <div id ="circles_ripple" class="circles ripple">
      <span class="lines">
        <i class="left-line"></i>
        <i class="right-line"></i>
      </span>
      <div class="label-gradient">
        <span class="left-label">Extracting and filtering the information</span>
        <span class="right-label">Categorised on <strong>Intent</strong> and <strong>Complexity</strong></span>
      </div>
        <div class="ripple-circles">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>`)
      ;
    // this.generateDart(dart);

    const socialDataGroup = problemDataTypes.append('g')
    .attr({
      id: 'svg-problem-data-social',
      class: 'svg-problem-data-social',
      transform: 'translate(300, 0)'
    });
  socialDataGroup
    .append('image')
    .attr({
      'xlink:href': jsonData.problem_section_images[0].socialBgImage,
      height: 250,
      width: 250,
      transform: 'translate(-125,-5)'
    });

  socialDataGroup.append('text')
    .text('SOCIAL')
    .attr({ transform: 'translate(-60,50)rotate(-45)' })
    .attr('font-size', '15px')
    .style({
      'text-anchor': 'middle',
      'fill': '#3E3E3E',
      'opacity': 1,
    });
    const symbolSocialData = this.drawBigDimond('problem-social', 13, 18, () => '#ffffff', (ln, n) => {
      if ((ln === 2) || (ln === 4) || (ln === 6 && (n % 3 === 0)) || (ln === 8 && (n % 4 === 0))) {
        return 0;
      } else {
        return 0.3;
      }
    });
    const problemSocialSquareSymbol = socialDataGroup.selectAll('.proclem-social-squareSymbol')
      .data(symbolSocialData)
      .enter()
      .append('path')
      .attr({
        'id': d => d.id,
        'd': d3.svg.symbol().type('square').size(100),
        'stroke-width': 1,
        'class': 'proclem-social-squareSymbol',
        'fill': d => {
          d.finalX = 328;
          d.finalY = 470;
          d.finalColor = this.colors[getRandomIntInclusive(0, this.colors.length - 1)];
          d.isRemove = (getRandomIntInclusive(0, 4) === 0) ? true : false;
          d.ang = getRandomIntInclusive(1, 89);
          return d.color;
        },
        'transform': d => `translate(${d.x}, ${d.y + getRandomArbitrary(2, 10)}) rotate(${d.ang})`
      })
      .style('opacity', 0);


    const medicalDataGroup = problemDataTypes.append('g')
      .attr({
        id: 'svg-problem-data-medical',
        class: 'svg-problem-data-medical',
        transform: 'translate(590, -25)'
      });
    medicalDataGroup
      .append('image')
      .attr({
        'xlink:href': jsonData.problem_section_images[1].medicalImage,
        height: 300,
        width: 300,
        transform: 'translate(-150,-7)'
      });

    medicalDataGroup.append('text')
      .text('MEDICAL CONVERSATION')
      .attr({ transform: 'translate(-80,65)rotate(-45)' })
      .attr('font-size', '15px')
      .style({
        'text-anchor': 'middle',
        'fill': '#3E3E3E',
        'opacity': 1,
        // 'font-weight': 'bold'
      });


    const symbolMedicalData = this.drawBigDimond('problem-medical', 14, 20, () => '#ffffff', (ln, n) => {
      if ((ln % 5 === 0 && n % 2 === 0) || (ln % 3 === 0 && n % 3 === 0) || (ln % 2 === 0 && n % 2 === 0)) {
        return 0;
      } else {
        return 0.3;
      }
    });
    const problemMedicalSquareSymbol = medicalDataGroup.selectAll('.problem-medical-squareSymbol')
      .data(symbolMedicalData)
      .enter()
      .append('path')
      .attr({
        'id': d => d.id,
        'd': d3.svg.symbol().type('square').size(100),
        'stroke-width': 1,
        'class': 'problem-medical-squareSymbol',
        'fill': d => {
          d.finalX = 38;
          d.finalY = 495;
          d.finalColor = this.colors[getRandomIntInclusive(0, this.colors.length - 1)];
          d.isRemove = (getRandomIntInclusive(0, 4) === 0) ? true : false;
          d.ang = getRandomIntInclusive(1, 89);
          return d.color;
        },
        'transform': d => `translate(${d.x}, ${d.y + getRandomArbitrary(2, 6)}) rotate(${d.ang})`
      })
      .style('opacity', 0);

    const researchDataGroup = problemDataTypes.append('g')
      .attr({
        id: 'svg-problem-data-research',
        class: 'svg-problem-data-research',
        transform: 'translate(940, -60)'
      });
    researchDataGroup
      .append('image')
      .attr({
        'xlink:href': jsonData.problem_section_images[2].researchImage,
        height: 370,
        width: 370,
        transform: 'translate(-185,-8)'
      });

    researchDataGroup.append('text')
      .text('RESEARCH PUBLICATIONS')
      .attr({ transform: 'translate(-100,85)rotate(-45)' })
      .attr('font-size', '15px')
      .style({
        'text-anchor': 'middle',
        'fill': '#3E3E3E',
        'opacity': 1,
        // 'font-weight': 'bold'
      });

    const symbolResearchData = this.drawBigDimond('problem-research', 19, 18, () => '#ffffff', (ln, n) => {
      if ((ln === 2) || (ln === 4) || (ln === 6 && (n % 2 === 0))) {
        return 0;
      } else {
        return 0.3;
      }
    });
    const problemResearchSquareSymbol = researchDataGroup.selectAll('.problem-research-squareSymbol')
      .data(symbolResearchData)
      .enter()
      .append('path')
      .attr({
        'id': d => d.id,
        'd': d3.svg.symbol().type('square').size(100),
        'stroke-width': 1,
        'class': 'problem-research-squareSymbol',
        'fill': d => {
          d.finalX = -313;
          d.finalY = 530;
          d.finalColor = this.colors[getRandomIntInclusive(0, this.colors.length - 1)];
          d.isRemove = (getRandomIntInclusive(0, 4) === 0) ? true : false;
          d.ang = getRandomIntInclusive(1, 89);
          return d.color;
        },
        'transform': d => `translate(${d.x}, ${d.y + getRandomArbitrary(4, 10)}) rotate(${d.ang})`
      })
      .style('opacity', 0);

    const imageColor = ['#909090', '#1e83a8'];
    const imagesdata = jsonData.data_problem_images;
    imagesdata.forEach((element: any, i) => {
      element.count = imagesdata.length;

    });


    const ids = _.shuffle(d3.range(imagesdata.length));
    const icon = svg.selectAll('.pathImages')
      .data(imagesdata)
      .enter()
      .append('g')
      .each(function (d, i) {
        d.scale = i>=0 && i<7 ? getRandomArbitrary(3.5, 5):i>=7 && i<=10?getRandomArbitrary(5, 6) : getRandomArbitrary(6,7.5);
        d.rotate = getRandomIntInclusive(0, 45);
        const size = 6;
        d3.select(this)
          .attr({
            'class': 'pathImages',
            'transform': function(){ return `translate(${d.x - 10}, ${d.y - 20})rotate(${d.rotate}) scale(${d.scale})`},
          })
          .attr({ 'id': 'pathImages_' + ids[i] })
          .style('opacity', 0)
          .append('g')
          ;
        d3.select(this).select('g')
          .append('rect')
          .attr({
            height: size,
            width: size,
          })
          .style({
            'fill': () => {
              return imageColor[getRandomIntInclusive(0, 1)];
            }
          })
          ;
        d3.select(this).select('g')
          .append('image')
          .attr({
            'xlink:href': d.d,
            'width': size - 1,
            'height': size - 1,
            'transform': 'translate(.5, .5)'
          })
        // .style('opacity', 0)
      });

    let aspect = { heightAspect, widthAspect };
    let structureDataShowSymbolRange;
    let socialSymbolRange;
    let medicalSymbolRange;
    let researchSymbolRange;
    let iconOpacity;
    let iconEnd;
    svg.style({
      'margin-bottom': (heightAspect * marginBottom) + 'px'
    });
    return {
      resize() {
        aspect = resize();
        svg.style({
          'margin-bottom': (heightAspect * marginBottom) + 'px'
        });
      },
      setScaleDomain(start, end, finalEnd = end) {
        // console.log('start, end',start, end)
        const animationStart = start;
        const firstAnimationEnd = HEIGHT * aspect.heightAspect * .25;
        const firstAnimationHalf = animationStart + ((firstAnimationEnd - animationStart) / 2);
        const problemPathSymbollAnimationStart = HEIGHT * aspect.heightAspect * .33; // firstAnimationEnd;
        const problemPathSymbollAnimationEnd = HEIGHT * aspect.heightAspect * .40;
        const structureSymbolShowAnimationStart = HEIGHT * aspect.heightAspect * .28;
        const structureSymbolShowAnimationEnd = HEIGHT * aspect.heightAspect * .33;
        const problemWallAnimationStart = end; // structureSymbolShowAnimationEnd + 50; // end + 50;
        const problemWallAnimationEnd = end + ((finalEnd - end) / 2);
        iconEnd = end / 3.70;

        icon.each((d) => {
          d.iconOpacity = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemPathSymbollAnimationEnd])
            .range([0, 15]).clamp(true);
          d.dimondStart = problemPathSymbollAnimationStart;
        });

        bgSquareNodes.each((d, i) => {
          const problemDataAnimationEnd = getRandomIntInclusive(firstAnimationHalf, firstAnimationEnd);
          const problemSymbolFinalAnimationEnd = getRandomIntInclusive(problemPathSymbollAnimationStart, problemPathSymbollAnimationEnd);
          if (d.animate) {
            d.animateXScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.x, d.finalX]).clamp(true);
            d.animateYScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.y, d.finalY]).clamp(true);
            d.animateAngScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.ang, 0]).clamp(true);
            d.animateSizeScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.size, 1]).clamp(true);
            d.animateOpacityScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd])
              .range([d.opacity, d.finalOpacity]).clamp(true);
            d.animateFinalXScale = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemSymbolFinalAnimationEnd]).range([d.finalX, d.fx]).clamp(true);
            d.animateFinalYScale = d3.scale.linear().domain([problemPathSymbollAnimationStart -1 , problemPathSymbollAnimationStart, problemSymbolFinalAnimationEnd]).range([d.finalY, d.finalY + 45, d.fy]).clamp(true);
            d.animateFinalSizeScale = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemSymbolFinalAnimationEnd]).range([1, 2]).clamp(true);
          }
        });
        squareNodes.each(d => {
          const problemDataAnimationEnd = getRandomIntInclusive(firstAnimationHalf, firstAnimationEnd);
          d.animateXScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.x, d.finalX]).clamp(true);
          d.animateYScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.y, d.finalY]).clamp(true);
          d.animateSizeScale = d3.scale.linear().domain([animationStart, problemDataAnimationEnd]).range([d.scale, 1]).clamp(true);
        });

        socialSymbolRange = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemPathSymbollAnimationEnd])
          .range([-1, problemSocialSquareSymbol.size()]).clamp(true);

        medicalSymbolRange = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemPathSymbollAnimationEnd])
          .range([-1, problemMedicalSquareSymbol.size()]).clamp(true);

        researchSymbolRange = d3.scale.linear().domain([problemPathSymbollAnimationStart, problemPathSymbollAnimationEnd])
          .range([-1, problemResearchSquareSymbol.size()]).clamp(true);


        problemSocialSquareSymbol.each((d) => {
          const end = getRandomIntInclusive(problemWallAnimationStart, problemWallAnimationEnd);
          d.animatePathXScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.x, d.finalX]).clamp(true);
          d.animatePathYScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.y, d.finalY]).clamp(true);
        });
        problemMedicalSquareSymbol.each((d) => {
          const end = getRandomIntInclusive(problemWallAnimationStart, problemWallAnimationEnd);
          d.animatePathXScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.x, d.finalX]).clamp(true);
          d.animatePathYScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.y, d.finalY]).clamp(true);
        });
        problemResearchSquareSymbol.each((d) => {
          const end = getRandomIntInclusive(problemWallAnimationStart, problemWallAnimationEnd);
          d.animatePathXScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.x, d.finalX]).clamp(true);
          d.animatePathYScale = d3.scale.linear().domain([problemWallAnimationStart, end])
            .range([d.y, d.finalY]).clamp(true);
        });
      },
      startAnimation(scrollTop) {

        if (scrollTop >= iconEnd && !d3.select('#circles_ripple').classed('in')) {
          d3.select('#circles_ripple').classed('in', true);
        }
        if (scrollTop < iconEnd + 20) {
          d3.select('#circles_ripple').classed('in', false);
        }
        icon.each(function (d) {
          if (d.iconOpacity(scrollTop) >= 1 && d.iconOpacity(scrollTop) <= 15) {
            d3.select('#pathImages_' + Math.floor(d.iconOpacity(scrollTop))).style('opacity', 1);
          }
          if (d.iconOpacity(scrollTop) + 1 === (d.count)) {
            icon.style('opacity', 1);
          }

          if (scrollTop >= (d.dimondStart)) {
            //icon.style('opacity', 1);
            // images.style('opacity', 1);
            problemDataTypes.style('opacity', 1);
          } else {
            problemDataTypes.style('opacity', 0);
            icon.style('opacity', 0);
            // images.style('opacity', 0);
          }
        });
        bgSquareNodes.each(function (d, i) {
          if (d.animate) {
            const self = d3.select(this);
            const newY = d.animateYScale(scrollTop);
            const newAngle = d.animateAngScale(scrollTop);
            self
              .attr({
                'transform':
                  `translate(${d.animateXScale(scrollTop)}, ${newY})
                              rotate(${newAngle}) scale(${d.animateSizeScale(scrollTop)})`
              })
              .style({
                'opacity': d.animateOpacityScale(scrollTop),
              });
            // condition is to add and remove 'vibrate-animation' class on path.
            const innerPath = self.select('path');
            if (d.animateXScale(scrollTop) === d.finalX) {
              innerPath.classed('vibrate-animation', false);
            } else if (!innerPath.classed('vibrate-animation')) {
              innerPath.classed('vibrate-animation', true);
            }
            if (d.finalY === newY) {
              const finalNewY = d.animateFinalYScale(scrollTop);
              self
                .attr({
                  'transform':
                    `translate(${d.animateFinalXScale(scrollTop)}, ${finalNewY})
                              rotate(${d.ang}) scale(${d.animateFinalSizeScale(scrollTop)})`
                });
              if (finalNewY === d.fy) {
                self.style({
                  'opacity': 0,
                });
              }
            }
          }
        });
        squareNodes.each(function (d) {
          const self = d3.select(this);
          d3.select(this)
            .attr({
              'transform':
                `translate(${d.animateXScale(scrollTop)}, ${d.animateYScale(scrollTop)}) scale(${d.animateSizeScale(scrollTop)})`
            });
          if (d.animateXScale(scrollTop) === d.finalX) {
            self.style('opacity', 0);
          } else if (self.style('opacity') === '0') {
            self.style('opacity', d.opacity);
          }
        });


        problemSocialSquareSymbol.each(function (d, i) {
          let fOpacity = 0;
          if (socialSymbolRange(scrollTop) + 1 > (d.idCount)) {
            fOpacity = d.finalOpacity;
          }
          const attr: any = {};
          if (d.isRemove) {
            const newXVal = d.animatePathXScale(scrollTop);
            const newY = d.animatePathYScale(scrollTop);
            fOpacity = (newY + 25 >= d.finalY) ? 0 : fOpacity;
            const ang = (newXVal === d.finalX) ? 45 : d.ang;
            const color = (newXVal === d.x) ? 'white' : d.finalColor;
            fOpacity = (newXVal === d.x) ? fOpacity : getRandomArbitrary(0.2, 0.9);
            fOpacity = (newY > (d.finalY - 10)) ? 0 : fOpacity;
            attr.fill = color;
            attr.transform = `translate(${newXVal}, ${newY}) rotate(${ang})`;
          }
          d3.select(this)
            .attr(attr)
            .style('opacity', fOpacity);
        });
        problemMedicalSquareSymbol.each(function (d, i) {
          let fOpacity = 0;
          if (medicalSymbolRange(scrollTop) + 1 > (d.idCount)) {
            fOpacity = d.finalOpacity;
          }
          const attr: any = {};
          if (d.isRemove) {
            const newXVal = d.animatePathXScale(scrollTop);
            const newY = d.animatePathYScale(scrollTop);
            fOpacity = (newY + 25 >= d.finalY) ? 0 : fOpacity;
            const ang = (newXVal === d.finalX) ? 45 : d.ang;
            const color = (newXVal === d.x) ? 'white' : d.finalColor;
            fOpacity = (newXVal === d.x) ? fOpacity : getRandomArbitrary(0.2, 0.9);
            fOpacity = (newY > (d.finalY - 10)) ? 0 : fOpacity;
            attr.transform = `translate(${newXVal}, ${newY}) rotate(${ang})`;
            attr.fill = color;
          }
          d3.select(this)
            .attr(attr)
            .style('opacity', fOpacity);
        });
        problemResearchSquareSymbol.each(function (d, i) {
          let fOpacity = 0;
          if (researchSymbolRange(scrollTop) + 1 > (d.idCount)) {
            fOpacity = d.finalOpacity;
          }
          const attr: any = {};
          if (d.isRemove) {
            const newXVal = d.animatePathXScale(scrollTop);
            const newY = d.animatePathYScale(scrollTop);
            fOpacity = (newY + 25 >= d.finalY) ? 0 : fOpacity;
            const ang = (newXVal === d.finalX) ? 45 : d.ang;
            const color = (newXVal === d.x) ? 'white' : d.finalColor;
            fOpacity = (newXVal === d.x) ? fOpacity : getRandomArbitrary(0.2, 0.9);
            fOpacity = (newY > (d.finalY - 10)) ? 0 : fOpacity;
            attr.fill = color;
            attr.transform = `translate(${newXVal}, ${newY}) rotate(${ang})`;
          }
          d3.select(this)
            .attr(attr)
            .style('opacity', fOpacity);
        });
      }
    };
  }

  private initOutcomesSection(containerId) {
    const container = d3.select('#' + containerId);
    const WIDTH = 1280 || container.node().clientWidth || container.node().offsetWidth;
    const HEIGHT_OFFSET = 420 / 1280;
    const HEIGHT = WIDTH * HEIGHT_OFFSET;
    const svg = container.append('svg')
      .attr({
        width: WIDTH,
        height: HEIGHT
      });
    const { resize, heightAspect, widthAspect } = this.responsivefy(svg);

    const outcomesGroup = svg
      .append('g')
      .attr({
        id: 'svg-outcomes',
        class: 'svg-outcomes'
      });

    outcomesGroup.append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': WIDTH,
        'height': HEIGHT
      })
      .html(`
        <div id="outcome-section" class="outcome-section">
          <div class="outcome-arrow-origin">
            <div class="outcome-arrow one"></div>
            <div class="outcome-arrow two"></div>
            <div class="outcome-arrow three"></div>
            <div class="outcome-arrow four"></div>
          </div>
          <div class="outcome one">Increased consistency of results
            by reducing human subjectivity</div>
          <div class="outcome two">~100X savings in time through
            automation leading to high productivity</div>
          <div class="outcome three">Discover concepts that are
            difficult to identify manually by
            exploiting semantic relationships</div>
          <div class="outcome four">Solutions that can scale horizontally
            and vertically with domain training</div>
        </div>
      `);
    let aspect = { heightAspect, widthAspect };
    let showSection;
    return {
      resize() {
        aspect = resize();
      },
      setScaleDomain(start, end, finalEnd = end) {
        showSection = end / 1.045;
      },
      startAnimation(scrollTop) {
        if (scrollTop >= showSection) {
          d3.select('#outcome-section').classed(' show', true);
          d3.select('#outcome-section').classed(' hide', false);
        } else {
          d3.select('#outcome-section').classed(' show', false);
          d3.select('#outcome-section').classed(' hide', true);
        }
      }
    };
  }

  private drawBigDimond(id, lineCount, sizeOfSquare, calColor, calOpacity) {
    const result = [];
    const ids = _.shuffle(d3.range(lineCount * lineCount));
    for (let i = 1, k = 1, j = 0; i < (lineCount * 2); i++) {
      let n = 1;
      let calX = j;
      while (k >= n) {
        result.push({
          x: calX,
          y: (i * (sizeOfSquare / 2)),
          id: `big_diamond_symbol_${id}_${ids[((i - 1) * n)]}`,
          finalOpacity: calOpacity(i, n),
          color: calColor(),
          idCount: ids[((i - 1) * n)],
        });
        calX += sizeOfSquare;
        n++;
      }
      if (i > (lineCount - 1)) {
        j += (sizeOfSquare / 2);
        k--;
      } else {
        j -= (sizeOfSquare / 2);
        k++;
      }
    }
    return result;
  }

  private initDataSection(containerId) {
    const that = this;
    const container = d3.select('#' + containerId);
    const WIDTH = 1280;
    const HEIGHT_OFFSET = 1000 / 1280;
    const HEIGHT = WIDTH * HEIGHT_OFFSET;
    const marginBottom = -92;
    const svg = container.append('svg')
      .attr({
        width: WIDTH,
        height: HEIGHT
      });
    const { resize, heightAspect, widthAspect } = this.responsivefy(svg);
    const dataGroup = svg.append('g')
      .attr({
        id: 'svg-data',
        class: 'svg-data',
        transform: 'translate(260, 0)'
      });

    const mainDataGrpup = dataGroup.append('g').attr({
      transform: 'translate(365, 0)'
    });

    const mainImageData = 'data:image/png;base64,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';

    const rectGroup = mainDataGrpup.append('g');
    rectGroup
      .append('image')
      .attr({
        'xlink:href': mainImageData,
        height: 370,
        width: 370,
        transform: 'translate(-185,-8)'
      });

    rectGroup.append('text')
      .text('INSIGHTS')
      .attr({ transform: 'translate(0,190)' })
      .attr('font-size', '32px')
      .style({
        'text-anchor': 'middle',
        'fill': '#1f0077',
        'opacity': 1,
        'font-weight': 'bold'
      });

    const symbolData = this.drawBigDimond('data', 15, 23, () => 'white', (ln, n) => {
      if ((ln === 14 && n > 4 && n < 11) || (ln === 15 && n > 4 && n < 12) || (ln === 16 && n > 4 && n < 11)) {
        return 0;
      } else {
        return 0.3;
      }
    });
    const squareSymbol = rectGroup.selectAll('.squareSymbol')
      .data(symbolData)
      .enter()
      .append('path')
      .attr({
        'id': d => d.id,
        'd': d3.svg.symbol().type('square').size(200),
        'stroke-width': 1,
        'class': 'squareSymbol',
        'fill': d => d.color,
        'transform': d => `translate(${d.x}, ${d.y + 4.5}) rotate(45)`
      })
      .style('opacity', 0);

    const data_data_insights_points = jsonData.data_data_insights_points;

    const StraitlineFunction = d3.svg.line().x(d => d.x).y(d => d.y);

    const dropPathsGroup = dataGroup.selectAll('.data-insights-path')
      .data(data_data_insights_points)
      .enter()
      .append('g')
      .each(function (d, i) {
        const gSelf = d3.select(this);
        gSelf
          .append('path')
          .attr({
            'class': 'data-insights-path',
            'd': StraitlineFunction(d.pathData),
            'stroke': d.color,
            'stroke-width': 3,
            'fill': 'none'
          })
          .style({
            'stroke-dasharray': function () {
              const pos = i + 1;
              if ((pos === 4) || pos === 8 || pos === 2 || pos === 6) {
                d.group = 4;
              } else if (pos === 3 || pos === 7) {
                d.group = 3;
              } else {
                d.group = 1;
              }
              d.startX = d.pathData[2].x;
              d.startY = d.pathData[2].y;
              d.finalX = getRandomIntInclusive(590, 600);
              d.finalY = getRandomIntInclusive(990, 995);
              d.totalLength = d3.select(this).node().getTotalLength();
              return d.totalLength + 'px, ' + d.totalLength + 'px';
            },
            'stroke-dashoffset': () => d.totalLength
          });
        gSelf.append('path')
          .attr({
            'class': 'data-insights-path-symbol',
            'd': d3.svg.symbol().type('square').size(225),
            'stroke': 'white',
            'stroke-width': 1,
            'fill': d.color,
            'transform': `translate(${d.pathData[0].x}, ${d.pathData[0].y}) rotate(45)`
          })
          .style({
            opacity: 0
          });

        gSelf.append('g')
          .attr('class', 'data-insights-rectangle-group')
          .style('opacity', 0)
          .append('rect')
          .attr({
            height: 75,
            width: 75,
            transform: (d) => 'translate(' + d.pathData[2].x + ',' + (d.pathData[2].y - 11) + ')rotate(45)'

          }).style({ fill: (d) => d.color });

        gSelf.select('g').append('image')
          .attr({
            'xlink:href': d.imageData,
            'width': 52 - 1,
            'height': 52 - 1,
            'transform': (d) => 'translate(' + (d.pathData[2].x - 24) + ',' + (d.pathData[2].y + 18) + ')'
          });

        gSelf.select('g').append('text')
          .attr({
            'x': (d) => d.pathData[2].x,
            'y': (d) => d.pathData[2].y + 115
          })
          .attr('dy', '.3em')
          .style('text-anchor', 'middle')
          .attr('font-size', '15px')
          .text(function (d) { return d.text; })
          .call(wrap, 130)
          .style({
            'fill': d => d.textColor,
            'opacity': 1,
            'font-weight': 'bold'
          });

        gSelf.select('g').append('image')
          .attr({
            'xlink:href': d.clickbleImage,
            'width': 26 - 1,
            'height': 26 - 1,
            'transform': function (d) {
              const yPosition = ((d.text.length > 19 && d.text.length <= 37) ? 145
                : (d.text.length > 36 && d.text.length <= 44) ? 165 : d.text.length <= 19 ? 135 : 180);
              return 'translate(' + (d.pathData[2].x - 14) + ',' + (d.pathData[2].y + yPosition) + ')';
            }
          })
          .on('click', function () {
            if (d.noteBookUrl) {
              that._gaService.triggerEvent('DS View', 'Usecase', 'Text Analytics');
              window.open(d.noteBookUrl, '_blank');
            }
          }).style({cursor:'pointer'});
      });

    function wrap(text, width) {
      text.each(function () {
        let text = d3.select(this),
          x = text.attr('x'),
          words = text.text().split(/\s+/).reverse(),
          word,
          line = [],
          lineNumber = 0,
          lineHeight = 1.1, // ems
          y = text.attr('y'),
          dy = parseFloat(text.attr('dy')) || 0,
          tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(' '));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(' '));
            line = [word];
            tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
          }
        }

      });
    }

    let aspect = { heightAspect, widthAspect };
    const setMarginBottom = () => {
      svg.style({
        'margin-bottom': (heightAspect * marginBottom) + 'px'
      });
    };
    setMarginBottom();
    let dataShowSymbolRange;
    return {
      resize() {
        aspect = resize();
        setMarginBottom();
      },
      setScaleDomain(start, end, finalEnd, viewportHalf) {
        const animationStart = start + (viewportHalf / 4); // start + ((aspect.heightAspect * 1));
        const symbolMoveOverPathEnd = start + viewportHalf;
        const CircleGroupLineDataStart = start + ((aspect.heightAspect * 1.34) * 140);
        const CircleGroupLineDataEnd = start + ((aspect.heightAspect * 1.34) * 220);
        const pathSymbolAnimateStart = symbolMoveOverPathEnd; // (end / 1.37);
        const pathSymbolAnimateEnd = symbolMoveOverPathEnd + viewportHalf; // (end / 1.15);
        const circleSymbolMoveToNextStart = end;
        const circleSymbolMoveToNextEnd = circleSymbolMoveToNextStart + viewportHalf;
        dataShowSymbolRange = d3.scale.linear().domain([animationStart, symbolMoveOverPathEnd])
          .range([-1, squareSymbol.size()]).clamp(true);

        dropPathsGroup.each(d => {
          let end = pathSymbolAnimateEnd;
          if (d.group === 1) {
            end = pathSymbolAnimateStart + ((end - pathSymbolAnimateStart) * 1 / 4);
          } else if (d.group === 2) {
            end = pathSymbolAnimateStart + ((end - pathSymbolAnimateStart) * 1 / 2);
          } else if (d.group === 4) {
            end = pathSymbolAnimateStart + ((end - pathSymbolAnimateStart) * 3 / 4);
          }
          const start = pathSymbolAnimateStart + ((end - pathSymbolAnimateStart) / 2);
          d.pathFillScale = d3.scale.linear().domain([start, end])
            .range([0, d.totalLength]).clamp(true);
          d.symbolTravelScale = d3.scale.linear().domain([start, end])
            .range([0, d.totalLength]).clamp(true);
          const scaleEnd = getRandomIntInclusive(circleSymbolMoveToNextStart +
            ((circleSymbolMoveToNextEnd - circleSymbolMoveToNextStart) / 2), circleSymbolMoveToNextEnd);
          d.symbolTONextSectionScale = {
            x: d3.scale.linear().domain([circleSymbolMoveToNextStart, scaleEnd])
              .range([d.startX, d.finalX]).clamp(true),
            y: d3.scale.linear().domain([circleSymbolMoveToNextStart, scaleEnd])
              .range([d.startY, d.finalY]).clamp(true)
          };
        });
      },
      startAnimation(scrollTop) {
        dropPathsGroup.each(function (d) {
          const newStrockDashOffsetVal = d.totalLength - d.pathFillScale(scrollTop);
          const opacityVal = (newStrockDashOffsetVal === 0) ? 1 : 0;
          const symbotOpacityVal = ((d.totalLength / 2) > newStrockDashOffsetVal) ? 1 : 0;
          const gSelf = d3.select(this);
          const symboles = gSelf.select('.data-insights-path-symbol');
          const path = gSelf.select('.data-insights-path').style('stroke-dashoffset', newStrockDashOffsetVal + 'px');
          gSelf.select('.data-insights-rectangle-group').style('opacity', opacityVal);
          const point = path.node().getPointAtLength(d.symbolTravelScale(scrollTop));
          if (point.y < d.startY) {
            symboles
              .attr({
                'transform':
                  `translate(${point.x}, ${point.y}) rotate(45)`
              })
              .style({
                'opacity': symbotOpacityVal
              });
          }
          if (point.y === d.startY) {
            const newY = d.symbolTONextSectionScale.y(scrollTop);
            symboles
              .attr({
                'transform':
                  `translate(${d.symbolTONextSectionScale.x(scrollTop)}, ${newY}) rotate(45)`
              });
            if (newY === d.finalY) {
              symboles.style('opacity', 0);
            } else {
              symboles.style('opacity', 1);
            }
          }
        });
        squareSymbol.each(function (d) {
          let fOpacity = 0;
          if (dataShowSymbolRange(scrollTop) + 1 > (d.idCount)) {
            fOpacity = d.finalOpacity;
          }
          d3.select(this)
            .style('opacity', fOpacity);
        });
      }
    };
  }

  private initSolutionSection(containerId) {
    const container = d3.select('#' + containerId);
    const WIDTH = 768;
    const HEIGHT_OFFSET = 700 / WIDTH;
    const HEIGHT = WIDTH * HEIGHT_OFFSET + 50;
    const svg = container.append('svg')
      .attr({
        width: WIDTH,
        height: HEIGHT
      });
    const { resize, heightAspect, widthAspect } = this.responsivefy(svg);
    svg.append('g')
      .attr({
        id: 'svg-list-solution',
        class: 'svg-list-solution',
        transform: `translate(0, 0)`
      })
      .append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': '100%',
        'height': '575'
      })
      .html(`<div id="solution-case-list" class="solution-list-container case-all">
          <ul class="solution-list left-list float-left">
              <li>Probalistic Graphical</li>
              <li>Semi supervised Anchor</li>
              <li>Supervised Classifiction</li>
              <li>Transfer Learning</li>
              <li>Unsupervised Topic Model</li>
              <li>Network Analysis</li>
          </ul>
          <ul class="solution-list right-list float-right">
              <li>Semantic Features</li>
              <li>Syntactic Features</li>
              <li>Domain Ontologies</li>
          </ul>
      </div>`);
    const solutionDivGroup = svg.append('g')
      .attr({
        id: 'svg-div-solution',
        class: 'svg-div-solution',
        transform: `translate(264, 75)`
      });
    const fo = solutionDivGroup.append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': '30%',
        'height': '400'
      });
    const solutionGroup = solutionDivGroup.append('g')
      .attr({
        id: 'svg-solution',
        class: 'svg-solution',
        transform: `translate(36, 203)`
      });
    const solutionHighliterGroup = solutionDivGroup.append('g')
      .attr({
        id: 'svg-highliter-solution',
        class: 'svg-highliter-solution',
        transform: `translate(36, 203)`
      });
    const div = fo.append('xhtml:div')
      .attr({
        'id': 'solution-case-container',
        'class': 'solution-case-container'
      });
    const typingDiv = div.append('xhtml:div')
      .attr({
        'id': 'solution-case-typing-container',
        'class': 'solution-case-typing-container cursor'
      });
    // solutionDivGroup.append('path')
    //   .attr({
    //     'd': (d) => d3.svg.symbol().type('square').size(1225)(),
    //     'class': 'solutionTopCircle',
    //     'id': 'solutionTopCircle',
    //     'transform': (d) => `translate(115, 0) rotate(45)`
    //   })
    //   .style({
    //     'fill': '#6992B1',
    //     'stroke-width':'1px',
    //     'stroke':'#FFFFFF'
    //   });
    const lineData = [
      { 'x': 0, 'y': 0 },
      { 'x': 0, 'y': 391 },
      { 'x': 100, 'y': 391 }
    ];
    const StraitlineFunction = d3.svg.line()
      .x(d => d.x)
      .y(d => d.y);
    let pathLength = 0;
    const path = solutionGroup.append('path')
      .attr('d', StraitlineFunction(lineData))
      .attr('stroke', '#CFD7DD')
      .attr('stroke-width', 2)
      .attr('fill', 'none')
      .style({
        'stroke-dasharray': function (d) {
          pathLength = d3.select(this).node().getTotalLength();
          return pathLength + 'px, ' + pathLength + 'px';
        },
        'stroke-dashoffset': d => `${pathLength}px`
      });

    const pathCircleData = [];
    const circleRainColors = ['#FACCCC', '#D0C5F2', '#ADDEE8', '#FFD7AA', '#9CD4FA', '#E8B7D4'];
    for (let i = 0; i < 6; i++) {
      const d = {
        x: 0,
        y: 0,
        finalY: HEIGHT + ((6 - i) * 60),
        size: 200,
        id: `solution_rain_circle_${i}`,
        color: circleRainColors[i]
      };
      pathCircleData.push(d);
    }
    const pathCircleNodes = solutionGroup.selectAll('.pathCircle')
      .data(pathCircleData)
      .enter().append('path')
      .attr({
        'd': (d) => d3.svg.symbol().type('square').size(d.size)(),
        'class': 'pathCircle',
        'id': d => d.id,
        'transform': (d) => `translate(${d.x}, ${d.y}) rotate(45)`
      })
      .style({
        'fill': d => d.color,
        'opacity': 0
      });
    const dart = solutionGroup.append('g')
      .attr({
        id: 'solution-dart-circle',
        class: 'solution-dart-circle',
        'transform': `translate(43, 350)`,
      })
      .style('opacity', 0);
    dart.append('foreignObject')
      .attr({
        'x': 0,
        'y': 0,
        'width': 120,
        'height': 120
      })
      .html(`<div class="solution-ripple-circles in ripple">
        <div class="ripple-circles">
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
          <i></i>
        </div>
      </div>`);
    // ;
    // this.generateDart(dart);
    let aspect = { heightAspect, widthAspect };
    let caseChangeScale = null;
    let lastCase;
    let pathCircleNodeScale;
    let pathFillScale;
    let animationStart;
    let pathCircleStart;
    let lastCalled = false;
    return {
      resize() {
        aspect = resize();
      },
      setScaleDomain(start, end, finalEnd = end, halfViewPort) {
        animationStart = start + (halfViewPort / 2);
        const animationEnd = end - ((finalEnd - end) / 2);
        pathCircleStart = animationEnd;
        const pathCircleEnd = end + ((finalEnd - end) / 2);
        caseChangeScale = d3.scale.linear().domain([animationStart - 1 , animationStart, animationEnd])
          .range([void 0, 0, (jsonData.data_solution_cases.length)]).clamp(true);
        pathCircleNodeScale = d3.scale.linear().domain([pathCircleStart, pathCircleEnd])
          .range([0, ((pathLength * 2) - 100)]).clamp(true);
        pathFillScale = d3.scale.linear().domain([pathCircleStart, end])
          .range([0, pathLength]).clamp(true);
      },
      startAnimation: (scrollTop) => {
        if (scrollTop < animationStart) {
          this.resetSolutionCase('solution-case-typing-container', solutionHighliterGroup);
          lastCase = void 0;
        } else {
          const newCaseNo = Math.abs(Math.round(caseChangeScale(scrollTop) - .51)); // Math.round(caseChangeScale(scrollTop));
          if (newCaseNo !== lastCase) {
            lastCase = newCaseNo;
            lastCalled = false;
            if (this.unsubscribeTypingAnimation !== null) {
              clearTimeout(this.unsubscribeTypingAnimation);
            }
            this.initSolutionCaseSection
              ('solution-case-typing-container', 50, newCaseNo, solutionHighliterGroup, solutionDivGroup, true);
          }
          if (scrollTop >= pathCircleStart && !lastCalled) {
            lastCalled = true;
            if (this.unsubscribeTypingAnimation !== null) {
              clearTimeout(this.unsubscribeTypingAnimation);
            }
            this.initSolutionCaseSection
              ('solution-case-typing-container', 0, newCaseNo, solutionHighliterGroup, solutionDivGroup, false);
          }
          pathCircleNodes.each(function (d, i) {
            const diffFactorForEachShapes = (pathCircleNodeScale(scrollTop) === pathLength) ? 0 : (i * 30);
            const point = path.node().getPointAtLength(pathCircleNodeScale(scrollTop) - diffFactorForEachShapes);
            const self = d3.select(this);
            if (i === 0 && (pathLength === (point.x + point.y))) {
              dart.style('opacity', 1);
            } else if (i === 0 && (pathLength !== (point.x + point.y))) {
              dart.style('opacity', 0);
            }
            self
              .attr({
                'transform':
                  `translate(${point.x}, ${point.y}) rotate(45)`
              })
              .style({
                'opacity': (point.y >= 70) ? 1 : 0
              });
          });
          const updatePathFill = pathFillScale(scrollTop);
          path.style('stroke-dashoffset',
            (pathLength - updatePathFill) + 'px');
            // ((updatePathFill < (pathLength * .4)) ? (pathLength * .4) : updatePathFill))
        }
      }
    };
  }

  private initSolutionCaseSection(containerId, speed, caseNo, highliter, container, withTyping = true) {
    // values to keep track of the number of letters typed, which quote to use. etc. Don't change these values.
    const cases = jsonData.data_solution_cases;
    const element = document.getElementById(containerId);
    element.innerHTML = '';
    highliter.selectAll('path').remove();
    d3.selectAll('.highliterTxt').remove();
    // d3.select('#solution-case-list')
    //   .attr('class', 'solution-list-container ' + cases[caseNo].activeClass);
    const processedWord = [];
    function endAll(transition, callback) {
      let n = 0;
      const args = arguments;
      transition.each(() => ++n)
        .each('end', () => (!--n && callback.apply(this, args)));
    }
    const self = this;
    const str = cases[caseNo].txt;
    function startTyping (i, withEffect) {
        const tagInfo = cases[caseNo].highLights.find(v => (v.start <= i && v.end >= i));
        if (tagInfo && i === tagInfo.end) {
          const spanId = processedWord.length;
          const newInnerHtml = element.innerHTML.slice(0, element.innerHTML.length - (tagInfo.end - tagInfo.start));
          element.innerHTML = (newInnerHtml + '<span class="highLight" id="highlitedSpan' + spanId + '">'
            + str.slice(tagInfo.start, tagInfo.end + 1) + '</span>');
          processedWord.push(tagInfo);
          const spanEle = d3.select(`#highlitedSpan${spanId}`).node();
          const highliterTxt = container.append('g')
            .attr({
              'class': 'highliterTxt',
              'transform': (d) => `translate(${(withEffect) ? spanEle.offsetLeft : 55},
                                              ${(withEffect) ? spanEle.offsetTop : (193 + (processedWord.length - 1) * 35)})`
            });
          const txtRect = highliterTxt
            .append('rect')
            .attr({
              width: spanEle.offsetWidth,
              height: spanEle.offsetHeight,
              x: 0,
              y: -1,
              fill: ((withEffect) ? '#6992B1' : 'transparent')
            });
          const txt = highliterTxt
            .append('text')
            .text(tagInfo.word)
            .attr({
              'x': 5,
              'y': 15,
              'font-family': 'DINProMedium',
              'font-size': '16px',
              'fill': () => ((withEffect) ? '#ffffff' : '#000000')
            });
          if (withEffect) {
            highliterTxt.transition()
              .duration(500)
              .delay(100)
              .attr({
                'transform': `translate(55, ${193 + (processedWord.length - 1) * 35})`
              })
              .call(endAll, function () {
                txtRect.attr({ fill: 'transparent' });
                txt.attr({ fill: '#000000' });
              });
          }
          highliter.append('path')
            .attr({
              'd': (d) => d3.svg.symbol().type('square').size(200)(),
              'class': 'highliterCircle',
              'transform': (d) => `translate(0, ${(processedWord.length - 1) * 35}) rotate(45)`
            })
            .style({
              'fill': '#6992B1'
            });
        } else {
          element.innerHTML = (element.innerHTML + str.charAt(i));
        }
    }
    if (withTyping) {
      let i = 0;
      (function typingEffect() {
        if (i < str.length) {
          startTyping(i, true);
          self.unsubscribeTypingAnimation = setTimeout(function () { typingEffect(); }, speed);
          i++;
        }
      })();
    } else {
      for (let i = 0; i < str.length; i++) {
        startTyping(i, false);
      }
    }
  }

  private resetSolutionCase(containerId, highliter) {
    if (this.unsubscribeTypingAnimation !== null) {
      clearTimeout(this.unsubscribeTypingAnimation);
    }
    const element = document.getElementById(containerId);
    element.innerHTML = '';
    highliter.selectAll('path').remove();
    d3.selectAll('.highliterTxt').remove();
  }
  private generateDart(group) {
    const appendCircle = (g, cx, cy, r, fill, x = 0, y = 0) => {
      g.append('circle')
        .attr({
          cx,
          cy,
          r,
          'transform': `translate(${x}, ${y})`
        })
        .style('fill', fill);
    };
    appendCircle(group, 20, 20, 20, '#8d6bc3');
    appendCircle(group, 16.66, 16.66, 16.66, '#c9b14c', 3.3, 3.3);
    appendCircle(group, 13.32, 13.32, 13.32, '#5055d1', 6.64, 6.64);
    appendCircle(group, 9.98, 9.98, 9.98, '#1da1f2', 9.98, 9.98);
    appendCircle(group, 6.64, 6.64, 6.64, '#c94c64', 13.32, 13.32);
    appendCircle(group, 3.3, 3.3, 3.3, '#50d19a', 16.66, 16.66);
  }
  /**
   * This is Visble Section change Handler.
   *
   * @param $event - Section Id
   */
  onScrollSecionChange($event) {
    this.onVisibleSectionChange.emit($event);
  }

  ngOnDestroy(): void {
    if (this.unsubscribeResize) {
      this.unsubscribeResize();
    }
    if (this.unsubscribeAnimationFrame) {
      window.cancelAnimationFrame(this.unsubscribeAnimationFrame);
    }
    if (this.unsubscribeTypingAnimation) {
      clearTimeout(this.unsubscribeTypingAnimation);
    }
  }
}

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
